import { CommonModule } from "@angular/common";
import { Component, Output, EventEmitter } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BreadcrumbComponent } from "../breadcrumb/breadcrumb.component";
import { NavService } from "../../services/nav.service";
import { SearchService } from "../../services/search.service";
import { AuthService } from "../../../auth/auth.service";
import { TranslateModule } from "@ngx-translate/core";
import { LanguageSwitcherComponent } from "../../../components/language-switcher/language-switcher.component";
import { Roles } from "../../models";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [FormsModule, RouterModule, CommonModule, BreadcrumbComponent, TranslateModule, LanguageSwitcherComponent],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  @Output() customerAdded = new EventEmitter<any>();

  public isFlip: boolean = false;
  public isSearchOpen: boolean = false;
  public open: boolean = false;
  userRole;
  isMenuOpen = false;

  readonly isAdmin = this.authService.isAdmin;

  constructor(public navService: NavService, public searchService: SearchService, private authService: AuthService) {
    this.userRole = this.authService.getRole();
  }

  sidebarToggle() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  closeMenu() {
    this.isMenuOpen = false;
  }

  isRoleAdmin() {
    return this.userRole === Roles.Admin;
  }

  onCustomerAdded(customer: any) {
    this.customerAdded.emit(customer);
  }

  downloadHelp() {
    const link = document.createElement('a');
    link.href = '/assets/helpPdf/Инструкции_Акция_Italon.pdf';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.click();
  }
}
